@if (initialized) {
    <div class="surface-0 shadow-1 px-4 py-3 flex align-items-center justify-content-between">
        <div class="flex align-items-center gap-3">
            <i class="fa-regular fa-bell text-xl text-primary"></i>
            <div class="flex flex-column">
                <span class="text-xl font-semibold">{{ name }}</span>
                @if (groupName) {
                    <span class="text-sm text-color-secondary">{{ groupName }}</span>
                }
            </div>
        </div>
        <!-- Config Check Summary Badge (clickable to open popover) -->
        @if (configCheckResult) {
            <div class="cursor-pointer" (click)="configCheckPopover.toggle($event)">
                @if (configCheckResult.totalErrors > 0) {
                    <p-tag [value]="configCheckResult.totalErrors + ' Fehler'" severity="danger" icon="fa-solid fa-circle-xmark"></p-tag>
                } @else if (configCheckResult.totalWarnings > 0) {
                    <p-tag [value]="configCheckResult.totalWarnings + ' Warnung' + (configCheckResult.totalWarnings > 1 ? 'en' : '')" severity="warn" icon="fa-solid fa-triangle-exclamation"></p-tag>
                } @else {
                    <p-tag value="Alles OK" severity="success" icon="fa-solid fa-circle-check"></p-tag>
                }
            </div>
        }
    </div>

    <!-- Config Check Popover -->
    <p-popover #configCheckPopover [style]="{width: '28rem', maxHeight: '80vh'}">
        <div class="flex flex-column gap-3">
            <div class="flex align-items-center gap-2 pb-2 border-bottom-1 border-200">
                <i class="fa-regular fa-clipboard-check text-xl text-primary"></i>
                <span class="font-semibold text-lg">Konfigurationspruefung</span>
            </div>
            <div class="overflow-y-auto" style="max-height: calc(80vh - 4rem)">
                <ns-config-check-result
                        [result]="configCheckResult"
                        [loading]="configCheckLoading"
                        [singleNotificationType]="true"
                        (onRefresh)="loadConfigCheck()">
                </ns-config-check-result>
            </div>
        </div>
    </p-popover>
}
